module.exports = __webpack_public_path__ + "static/img/15.33c5b91.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/6/sp/15.png
// module id = nd3q
// module chunks = 0